/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';

import { Switch } from '@oca/ui';

/**
 * Final-form wrapper for the `Switch` atom. Use with `type="checkbox"` so the
 * field exposes `input.checked`/`input.onChange`.
 */
export function SwitchFieldWrapper({ input, disabled }) {
  return (
    <Switch
      name={input.name}
      checked={!!input.checked}
      onChange={input.onChange}
      disabled={disabled}
    />
  );
}

SwitchFieldWrapper.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
  }).isRequired,
  disabled: PropTypes.bool,
};

SwitchFieldWrapper.defaultProps = {
  disabled: false,
};
